import { ReactComponent as WheelChair } from '../../../resources/images/svg/wheelchair.svg';
import { useBooking } from '../../contexts/ticketBookingContext/TicketBookingContext';
import { useWagonContext } from '../../contexts/wagonContext/wagonContext';
import useTranslation from '../../hooks/translation/useTranslation';
import getSeatStatus from '../../../utils/functions/booking/getSeatStatus';

function Seat({
  seat,
  bottom,
  chosenSeats,
  wagonNumber,
  reserveSeat,
  unReserveSeat,
  top,
  compartmentClassName,
  noDirection = false,
  seatPropertyIcon,
  hidePrice = false,
  seatTooltipExtraText,
}) {
  const { trans } = useTranslation();
  const { direction } = useWagonContext();
  const { prices, bookingData } = useBooking();

  const chooseSeat = () => {
    if (
      chosenSeats?.find(
        (chosenSeat) => JSON.stringify({
          seat_number: chosenSeat?.seat_number,
          wagon_number: chosenSeat?.wagon_number,
        })
                    === JSON.stringify({
                      seat_number: seat?.seat_number,
                      wagon_number: wagonNumber,
                    }),
      )
    ) {
      unReserveSeat(seat, wagonNumber);
    } else {
      reserveSeat(seat, wagonNumber);
    }
  };

  const getSeatPrice = () => {
    if (prices?.seatGroupPrices?.[seat?.seat_group_property_id]) {
      return prices?.seatGroupPrices?.[seat?.seat_group_property_id];
    }
    return prices?.seatClassPrices?.[seat?.seat_class_id];
  };

  const price = hidePrice ? undefined : getSeatPrice();

  return (
    <button
      type="button"
      className={`seat
       ${compartmentClassName}
       ${getSeatStatus({
        bookingData,
        direction,
        seat,
        chosenSeats,
        wagonNumber,
      })} ${noDirection && 'no-direction'}`}
      onClick={chooseSeat}
    >
      {!top && <div className="top-handle" />}
      <div className="seat-tooltip">
        <div>
          <p className="m-0 whitespace-nowrap">
            {seat?.seat_class}
          </p>
          <p className="m-0">
            N
            {seat?.seat_number}
          </p>
          {price && (
          <p className="m-0">
            {price}
            {trans('gel')}
          </p>
          )}
          {seatTooltipExtraText}
        </div>
      </div>
      <div className="back" />
      {bottom && <div className="bottom-handle" />}
      {seat?.seat_group_property_id === 12
                && <WheelChair className={`seat-property ${bottom && 'bottom'}`} />}
      {seatPropertyIcon && seatPropertyIcon}
    </button>
  );
}

export default Seat;
